import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_TEMPLATES_TEMPLATEID_PATH_KEY } from '@/swagger/constants/quiz-keys';
import { API_GET_QUIZ_BY_ID, KEY_GET_QUIZ_BY_ID } from '../constats';
import { MOCK_RESPONSE_GET_QUIZ_BY_ID } from '../mocks';

type GetQuizById = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_TEMPLATES_TEMPLATEID_PATH_KEY
>;

type RequestGetQuizById = GetQuizById['request']['path'];

type ResponseGetQuizById = GetQuizById['response']['body'];

type CallParamsGetQuizById = Omit<RequestGetQuizById, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetQuizById = ResponseGetQuizById;

type CallErrorGetQuizById = GenericApiError;

type CallSelectorsGetQuizById = {
  result: ResponseGetQuizById;
};

export const getQuizByIdCall = createGeneralCall<
  CallParamsGetQuizById,
  CallResponseGetQuizById,
  CallErrorGetQuizById,
  CallSelectorsGetQuizById
>({
  id: KEY_GET_QUIZ_BY_ID,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_QUIZ_BY_ID(org, payload.templateId);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  // @ts-ignore
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_QUIZ_BY_ID
    : undefined,
  selectors: {
    result: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
});
